import styles from './BrandMark.module.css';

/** Ícone do app (SPEC 1.1): squircle azul com uma linha curva branca ligando dois pontos. */
export function BrandMark({ size = 28 }: { size?: number }) {
  return (
    <svg className={styles.mark} width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <rect className={styles.bg} x="0" y="0" width="32" height="32" rx="9" />
      <path className={styles.route} d="M9 22.5c3.2 0 4.4-2.6 5.6-6.2S17.6 9.5 23 9.5" />
      <circle className={styles.dot} cx="9" cy="22.5" r="2.6" />
      <circle className={styles.dot} cx="23" cy="9.5" r="2.6" />
    </svg>
  );
}
